function lockPromoQuantities(cart) {
  if (!cart?.items?.length) return;

  cart.items.forEach((item) => {
    const isPromo =
      item.properties &&
      (item.properties._source === 'checkout_upsell' ||
        item.properties._source === 'checkout_free_gift');

    if (!isPromo) return;

    let productRow =
      document.querySelector(`[id="${item.key}"]`) || document.getElementById(item.key);

    if (!productRow) {
      const rows = document.querySelectorAll('.upcart-product-item, .styles_ProductRow__product__');
      rows.forEach((row) => {
        if (row.getAttribute('id') === item.key) {
          productRow = row;
        }
      });
    }

    if (!productRow) {
      const root = window.upcartDocumentOrShadowRoot || document;
      productRow =
        root.querySelector(`[id="${item.key}"]`) || root.getElementById?.(item.key);

      if (!productRow) {
        const allElements = document.querySelectorAll('*');
        for (const el of allElements) {
          if (el.shadowRoot) {
            productRow =
              el.shadowRoot.querySelector(`[id="${item.key}"]`) ||
              el.shadowRoot.getElementById(item.key);
            if (productRow) break;
          }
        }
      }
    }

    if (!productRow) return;

    const quantityField =
      productRow.querySelector('.styles_QuantityField__') ||
      productRow.querySelector('[class*="QuantityField"]');

    if (quantityField) {
      quantityField.style.setProperty('display', 'none', 'important');
      return;
    }

    const stepper =
      productRow.querySelector('[class*="stepper"]') ||
      productRow.querySelector('.styles_ProductRow__stepper__');
    if (stepper) {
      stepper.style.setProperty('display', 'none', 'important');
    }
  });
}

function checkAndLockUpCartProducts() {
  fetch(window.Shopify.routes.root + 'cart.js')
    .then((response) => response.json())
    .then(lockPromoQuantities)
    .catch(() => {});
}

let lockDebounceTimer;

function runLock(cart, delay = 300) {
  clearTimeout(lockDebounceTimer);
  lockDebounceTimer = setTimeout(() => {
    if (cart) {
      lockPromoQuantities(cart);
    } else {
      checkAndLockUpCartProducts();
    }
  }, delay);
}

function bindUpcartLockListeners() {
  if (window.__upcartLockPromoBound) return true;
  if (typeof window.upcartSubscribeCartLoaded !== 'function') return false;

  window.upcartSubscribeCartLoaded((event) => {
    runLock(event.cart);
  });

  window.upcartSubscribeCartUpdated((event) => {
    runLock(event.cart);
  });

  window.upcartSubscribeCartOpened(() => {
    runLock(null, 300);
  });

  if (typeof window.upcartSubscribeAddedToCart === 'function') {
    window.upcartSubscribeAddedToCart(() => {
      runLock(null, 300);
    });
  }

  if (typeof window.upcartSubscribeItemRemoved === 'function') {
    window.upcartSubscribeItemRemoved(() => {
      runLock(null, 300);
    });
  }

  window.__upcartLockPromoBound = true;
  return true;
}

function initUpcartLockListeners() {
  if (bindUpcartLockListeners()) return;

  let attempts = 0;
  const waitForApi = setInterval(() => {
    if (bindUpcartLockListeners() || ++attempts >= 40) {
      clearInterval(waitForApi);
    }
  }, 250);
}

initUpcartLockListeners();
